<template>
  <div class="__wrapper">
    <div class="__toolbar">
      <div class="__row __centered">
        <div class="__logo">
          <img src="../assets/icons/log2.svg" alt width="106px" height="27px" />
        </div>
        <div class="__buttons">
          <button class="__tr" @click="login">Sign In</button>
          <button class="__bg" @click="$router.push({ name: 'signup' })">
            Register
          </button>
        </div>
      </div>
    </div>
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="__section-center">
          <div class="section-center__layout">
            <div class="layout__right">
              <!-- Project -->
              <div class="__content-container" v-if="isProject && proj">
                <div class="not-user-info-widget">
                  <img
                    :src="$fullUrl('images/profiles/' + issuer.profile_picture)"
                  />
                  <div class="content">
                    <router-link
                      :to="{ name: 'profile-view', params: { id: issuer.id } }"
                    >
                      <span class="__colored">
                        {{
                          (issuer.first_name + " " + issuer.last_name)
                            | validate
                        }}
                      </span>
                    </router-link>
                    <span v-if="!action && isProject" class="text"
                      >has asked you to confirm that you worked together on this
                      project.</span
                    >
                    <span v-if="action && isProject" class="text"
                      >has asked you to Verify this project.</span
                    >
                  </div>
                </div>

                <div class="__card">
                  <div class="__tile">
                    <div class="name">{{ proj.name | validate }}</div>
                  </div>
                  <div class="__card-wrap">
                    <div class="column">
                      <h2 class="titlee">Company</h2>
                      <p>{{ proj.company.name | validate }}</p>

                      <h2 class="titlee">Time frame</h2>
                      <p class="date" v-if="proj.from">
                        <span style="margin-right: 4px">
                          {{ proj.from | formatDate | validate }}
                        </span>
                        <span v-if="proj.to"
                          >to {{ proj.to | formatDate | validate }}</span
                        >
                      </p>

                      <h2 class="titlee" v-if="proj.location">Location</h2>
                      <p v-if="proj.location">{{ proj.location | validate }}</p>

                      <h2 class="titlee" v-if="proj.description">
                        Description
                      </h2>
                      <p v-if="proj.description" v-html="proj.description"></p>
                    </div>
                  </div>
                </div>

                <div class="__aligned" v-if="action">
                  <button class="btn-out" @click="outsideProjectApprove()">
                    Approve
                  </button>
                  <button class="btn" @click="accept(true)">
                    Approve and Register
                  </button>
                  <button class="decline" @click="decline">
                    I don’t recognise this
                  </button>
                </div>
                <div class="__aligned" v-else>
                  <app-dialog
                    title="Project Invitation"
                    ask="Are you sure you want to accept this project invitation?"
                    yesText="Accept"
                    noText="Cancel"
                    yesBtnClass="btn-default"
                    @onComfirm="accept(false)"
                  >
                    <button class="btn">Accept invitation</button>
                  </app-dialog>
                  <button class="decline" @click="decline">
                    I don’t recognise this
                  </button>
                </div>
              </div>
              <!-- Employment -->
              <div class="__content-container" v-if="IsEmploy && employ">
                <div class="not-user-info-widget">
                  <img
                    :src="$fullUrl('images/profiles/' + issuer.profile_picture)"
                  />
                  <div class="content">
                    <router-link
                      :to="{ name: 'profile-view', params: { id: issuer.id } }"
                    >
                      <span class="__colored">
                        {{
                          (issuer.first_name + " " + issuer.last_name)
                            | validate
                        }}
                      </span>
                    </router-link>
                    <span v-if="action && employ" class="text"
                      >has asked you to Verify this employment.</span
                    >
                    <span v-if="!action && employ" class="text"
                      >has asked you to confirm that you worked together on this
                      employment.</span
                    >
                  </div>
                </div>
                <div class="__card">
                  <div class="__tile">
                    <div class="name">{{ employ.company.name | validate }}</div>
                  </div>
                  <div class="__card-wrap">
                    <div class="column">
                      <h2 class="titlee">Time frame</h2>
                      <p class="date" v-if="employ.from">
                        <span style="margin-right: 4px">
                          {{ employ.from | formatDate | validate }}
                        </span>
                        <span v-if="employ.to"
                          >to {{ employ.to | formatDate | validate }}</span
                        >
                      </p>

                      <h2 class="titlee" v-if="employ.location">Location</h2>
                      <p v-if="employ.location">
                        {{ employ.location | validate }}
                      </p>

                      <h2 class="titlee" v-if="employ.description">
                        Description
                      </h2>
                      <p
                        v-if="employ.description"
                        v-html="employ.description"
                      ></p>

                      <div class="members" v-if="employ.members">
                        <h2 class="titlee" v-if="employ.members.length > 0">
                          Members
                        </h2>
                        <div
                          class="___members"
                          v-if="employ.members.length > 0"
                        >
                          <div
                            class="___member"
                            v-for="(person, i) in employ.members"
                            :key="i"
                          >
                            <img
                              :src="
                                $fullUrl(
                                  'images/profiles/' + person.profile_picture
                                )
                              "
                            />
                            <span>
                              {{
                                (person.first_name + " " + person.last_name)
                                  | validate
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="__aligned" v-if="action">
                  <button class="btn-out" @click="outsideEmploymentApprove()">
                    Confirm
                  </button>
                  <button class="btn" @click="acceptEmp(true)">
                    Confirm and Register
                  </button>
                  <button class="decline" @click="decline">
                    I don’t recognise this
                  </button>
                </div>
                <div class="__aligned" v-else>
                  <app-dialog
                    title="Employment Invitation"
                    ask="Are you sure you want to accept this employment invitation?"
                    yesText="Accept"
                    noText="Cancel"
                    yesBtnClass="btn-default"
                    @onComfirm="acceptEmp(false)"
                  >
                    <button class="btn">Accept invitation</button>
                  </app-dialog>
                  <button class="decline" @click="decline">
                    I don’t recognise this
                  </button>
                </div>
              </div>
              <div class="__content-container" v-if="!proj && !employ">
                <h3>Data not found</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "invitation",
  mounted() {
    let issuer = this.$route.query.issuer;
    let reference = this.$route.query.reference;
    let type = this.$route.query.type;
    this.$store.dispatch("INVITE_USER_VIA_PROJECT", {
      issuer: issuer,
      reference: reference,
      type: type,
    });
  },
  computed: {
    ...mapGetters(["getInvitationData"]),
    issuer() {
      return this.getInvitationData.user;
    },
    proj() {
      if (this.isProject) return this.getInvitationData.project;
      else return null;
    },
    employ() {
      if (this.IsEmploy) return this.getInvitationData.employment;
      else return null;
    },
    action() {
      return this.$route.query.action === "verification";
    },
    isProject() {
      return this.$route.query.type === "project";
    },
    IsEmploy() {
      return this.$route.query.type !== "project";
    },
    id() {
      return this.proj.id;
    },
  },
  components: {
    appDialog,
  },
  methods: {
    outsideEmploymentApprove() {
      let vm = this;
      vm.$store.dispatch("CONFIRM_VERIFY_EMPLOYMENT", {
        id: vm.employ.id,
        user: vm.issuer.id,
      });
      vm.$notify({
        group: "status",
        title: "Important message",
        text: "Employment is confirmed",
        type: "success",
        duration: 3000,
      });
      vm.$router.push({
        name: "welcome",
      });
    },
    outsideProjectApprove() {
      let vm = this;
      vm.$store.dispatch("CONFIRM_VERIFY_PROJECT", {
        id: vm.id,
        user: vm.issuer.id,
      });
      vm.$notify({
        group: "status",
        title: "Important message",
        text: "Project is approved",
        type: "success",
        duration: 3000,
      });
      vm.$router.push({
        name: "welcome",
      });
    },
    goToAccount() {
      let type = this.isProject ? "project" : "employment";
      this.$router.push({
        name: "invitation_account",
        params: { type: type },
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    accept(check) {
      if (check) {
        this.$store.dispatch("CONFIRM_VERIFY_PROJECT", {
          id: this.id,
          user: this.issuer.id,
        });
        this.$router.push({
          name: "signup",
          params: { action: "disabled", type: "visitor" },
        });
      } else {
        this.$cookies.set("project-token", this.$route.query.reference);
        this.goToAccount();
      }
    },
    acceptEmp(check) {
      if (check) {
        this.$store.dispatch("CONFIRM_VERIFY_EMPLOYMENT", {
          id: this.employ.id,
          user: this.issuer.id,
        });
        this.$router.push({
          name: "signup",
          params: { action: "disabled", type: "visitor" },
        });
      } else {
        this.$cookies.set("employment-token", this.$route.query.reference);
        this.goToAccount();
      }
    },
    decline() {
      this.$router.push({ name: "welcome" });
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover,
a {
  text-decoration: none !important;
}
.h2 {
  font-size: 12px;
  font-weight: lighter;
  color: #6e6e6e;
  margin-top: 10px !important;
}

.__card {
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
}
.__wrapper {
  background: rgba(239, 239, 239, 0.49);
  min-height: 100%;
  .__toolbar {
    width: 100%;
    position: fixed;
    top: 0;
    height: 49.5px;
    background: linear-gradient(45deg, #1ba5a4, #1885ad);
    z-index: 9999;
    .__row {
      margin: 0 auto;
      width: 800px;
      display: flex;
      justify-content: space-between;
      .__buttons {
        display: flex;
        .__bg {
          border-radius: 5.3px;
          background-color: #ffffff;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #00749f;
        }
      }
      .__tr {
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        outline: none;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
      }
      button {
        padding: 0 20px;
        height: 30px;
      }
    }
  }
  .__head {
    height: 50px;
    margin-top: 48px;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;
    /*@media (min-width: 300px) and (max-width: 630px) {*/
    /*    display: none;*/
    /*}*/
  }
  .__body {
    overflow-y: auto;
    height: calc(100vh - 99px);
    padding-bottom: 30px;
    .__container {
      margin: 0 auto;
      width: 800px;
      padding-top: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        width: 90%;
      }
      .__section-center {
        min-width: 0;
        .section-center__layout {
          display: grid;
          grid-template-columns: 1fr;
          .layout__left {
            min-width: 0;
            h2 {
              color: #535353;
              margin-top: 20px;
              margin-left: 10px;
              font-size: 23px;
            }
            a:hover {
              text-decoration: none !important;
            }
            .item-row {
              padding: 10px 20px;
              &:hover {
                background: #1890a9;
              }
              img {
                margin-right: 10px;
              }
              span {
                color: #797979;
                font-size: 14px;
                font-weight: normal;
              }
              .fin {
                float: right;
                font-weight: bold;
                margin-top: 2px;
                margin-right: 0 !important;
                font-size: 12px;
              }
            }
            .item-row-active {
              background: #1890a9;
            }
            .__body {
              display: flex;
              flex-direction: column;
              padding: 10px;
              h3 {
                font-size: 14px;
                color: #000000;
                font-weight: bolder;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 30px;
              }
              .__item {
                margin-bottom: 10px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                padding-left: 20px;
                label {
                  color: #1885ad;
                  font-size: 14px;
                  cursor: pointer;
                  margin-right: 10px;
                  font-weight: normal;
                }
              }
            }
            .contact-card {
              display: flex;
              flex-direction: column;
              .section {
                width: 100%;
                display: flex;
                padding: 10px 0;
                justify-content: center;
                align-items: center;
                border-bottom: 2px solid #f5f5f5;
                flex-direction: column;
                img {
                  width: 60px;
                  height: 60px;
                  cursor: pointer;
                  margin-top: 0px;
                  border-radius: 100%;
                }
                h2 {
                  font-weight: normal;
                  color: #000000 !important;
                  line-height: 12px;
                  text-align: center;
                  margin: 5px 0 !important;
                  font-size: 15px;
                }
                span {
                  color: #4e4e4e;
                  text-align: center;
                  margin-top: 5px;
                  font-size: 14px;
                }
                label {
                  font-size: 14px;
                  text-align: center;
                  margin-top: 10px;
                  color: #808080;
                }
              }
              .sec {
                border-bottom: 2px solid #f5f5f5;
                padding-top: 0;
                span {
                  color: #808080;
                  text-align: center;
                  font-size: 13px;
                }
              }
            }
            .__suggestion-box {
              padding: 10px;
              .__body {
                margin-top: 0px;
                background: transparent;
                .__item {
                  display: flex;
                  margin-bottom: 20px;
                  flex-direction: row;
                  img,
                  .__logo {
                    width: 25px;
                    height: 25px;
                    border-radius: 100%;
                  }
                  .__logo {
                    background: #1885ad;
                    padding: 0 !important;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    span {
                      color: #fff;
                      font-size: 42px;
                      margin: 0 0 12px 12px;
                      font-weight: normal;
                    }
                  }
                  .__centered {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    margin-left: 10px;
                    justify-content: space-between;
                    .__text {
                      display: flex;
                      flex-direction: column;
                      h3 {
                        margin-bottom: 0;
                        font-weight: normal;
                        font-size: 13px;
                        cursor: pointer;
                      }
                      span {
                        margin-top: -5px;
                        font-size: 10px;
                      }
                      .__greyed {
                        color: #000;
                        cursor: default;
                      }
                      label {
                        font-size: 11px;
                      }
                    }
                    img {
                      padding: 5px;
                      border-radius: 100px;
                      width: 20px;
                      height: 20px;
                      background: #ececef;
                    }
                  }
                }
                .vertical {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                  span {
                    color: #959595;
                    font-size: 10px;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-bottom: 10px;
                    font-weight: normal;
                  }
                  h1 {
                    color: #959595;
                    font-size: 19px;
                    opacity: 0.6;
                    font-weight: normal;
                  }
                  label {
                    font-size: 11px;
                    font-weight: normal;
                    margin-top: 0px;
                    color: #959595;
                  }
                  img {
                    margin-top: 0px;
                  }
                }
              }
            }
          }
          .layout__right {
            .__content-container {
              position: relative;
              padding-top: 12px;
              .not-user-info-widget {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                padding-left: 20px;
                @media (min-width: 300px) and (max-width: 630px) {
                  padding-left: 0px;
                }
                img {
                  width: 40px;
                  height: 40px;
                  object-fit: cover;
                  border-radius: 50%;
                  margin-right: 15px;
                }
                .content {
                  font-size: 15px;
                  a {
                    margin-right: 5px;
                  }
                  span.text {
                    font-style: italic;
                  }
                }
              }
              .__card {
                background: #fff;
                border-radius: 3px;
                padding-bottom: 20px;
                margin-bottom: 10px;

                .__tile {
                  display: flex;
                  margin-top: 0px;
                  margin-bottom: 10px;
                  justify-content: space-between;
                  .name {
                    font-size: 19px;
                    color: #676767;
                    font-weight: 800;
                  }
                  .date {
                    font-size: 14px;
                    color: #707070;
                  }
                }
                .__card-wrap {
                  display: flex;
                  flex-direction: column;
                  .column {
                    display: flex;
                    flex-direction: column;
                    .titlee {
                      font-family: Avenir-Roman;
                      font-size: 15px;
                      color: #000000;
                      font-weight: 800;
                      margin-bottom: 10px;
                    }
                    p {
                      font-size: 14px;
                      color: #6e6e6e;
                      margin-bottom: 25px;
                    }
                    .___members {
                      margin-top: 10px;
                      display: flex;
                      .___member {
                        background: #999999 0% 0% no-repeat padding-box;
                        display: flex;
                        padding: 4px 12px 4px 5px;
                        opacity: 0.8;
                        justify-content: center;
                        align-items: center;
                        border-radius: 20px;
                        margin-right: 10px;
                        span {
                          color: #fff;
                          font-size: 12px;
                        }
                        img {
                          width: 30px;
                          height: 30px;
                          margin-right: 10px;
                          border-radius: 100%;
                          object-fit: cover;
                        }
                      }
                    }
                  }
                }
              }
              .__aligned {
                display: flex;
                margin-top: 20px;
                align-items: center;
                padding-left: 20px;
                @media (min-width: 300px) and (max-width: 630px) {
                  padding-left: 0px;
                }
                .btn-out {
                  outline: none;
                  font-size: 12px;
                  border: none;
                  width: 186px;
                  height: 38px;
                  border: 1px solid #1885ad;
                  color: #1885ad;
                  border-radius: 6px;
                  font-weight: 800;
                  margin-right: 15px;
                }
                .btn {
                  color: #fff;
                  outline: none;
                  font-size: 12px;
                  border: none;
                  width: 186px;
                  height: 38px;
                  background: transparent
                    linear-gradient(260deg, #1885ad 0%, #00a5a6 100%) 0% 0%
                    no-repeat padding-box;
                  border-radius: 6px;
                  font-weight: 800;
                }
                .decline {
                  font-family: "Nunito", sans-serif;
                  font-size: 12px;
                  height: 25px;
                  margin-left: 20px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.42;
                  letter-spacing: 0.36px;
                  text-align: left;
                  color: #1885ad;
                  font-weight: 800;
                }
              }
            }
          }
        }
      }
      .__section-right {
        min-width: 0;
      }
    }
    .floater {
      position: fixed;
      bottom: 0px;
      right: 10px;
    }
  }
}
.__colored {
  color: #1890a9;
}
.__green {
  color: #1ba5a4;
}
.__white {
  color: #ffffff;
}
.__v-space {
  margin-top: 15px !important;
}
.error {
  border: 1px solid maroon !important;
}
.__card {
  background: #fff;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
}
.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}
.lesss {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
}
.greyed {
  background: #f8f8f8;
}
</style>